import { View, ViewOpts } from '@play-co/timestep-core/ui';
import ShineFx from '../components/ShineFx';
import LangBitmapFontTextView from 'src/lib/ui/components/LangBitmapFontTextView';
import i18n from 'src/lib/i18n/i18n';

export default class Match2TournamentResultItem extends View {
  protected shine: ShineFx;
  protected label: LangBitmapFontTextView;

  constructor(opts: ViewOpts, label: string) {
    super(opts);
    this.shine = new ShineFx({ superview: this, scale: 0.5, opacity: 0.75 });
    new LangBitmapFontTextView({
      superview: this,
      align: 'center',
      verticalAlign: 'center',
      centerOnOrigin: true,
      size: 34,
      font: 'Title',
      width: 300,
      height: 100,
      color: '#FFFFFF',
      localeText: () => i18n(label),
      y: -85,
    });
    this.label = new LangBitmapFontTextView({
      superview: this,
      align: 'center',
      verticalAlign: 'center',
      centerOnOrigin: true,
      size: 38,
      font: 'Title',
      width: 300,
      height: 100,
      color: '#FFFFFF',
      localeText: () => '-',
      zIndex: 100,
    });
  }

  public enable() {
    this.label.hide();
    this.shine.show();
  }

  public disable() {
    this.label.show();
    this.shine.hide();
  }
}
